<template>
  <div class="tenders">
    <h1 class="tenders__h1">
      {{ $t('tendersTitle') }}
    </h1>
    <tabs :options="{ defaultTabHash: 'clients' }" class="tenders__tabs" @changed="onChangeTabs">
      <tab id="clients" :name="$t('tendersTab1Name')" class="text-animationFade containerMF">
        <div class="containerMF tenders__conteiner">
          <div class="tenders__delivery">
            <div class="tenders__delivery-content text-animationFade">
              <h2 v-appear class="tenders__h2">
                {{ $t('tendersTab1Title') }}
              </h2>
            </div>
            <div class="tenders__delivery-image values animationFade-img">
              <img v-lazy="ourValues" alt="" />
            </div>
          </div>
          <div class="tenders__delivery">
            <div class="tenders__delivery-content text-animationFade">
              <h4 v-appear class="tenders__delivery-h4">
                {{ $t('tendersTab1DeliveryTitle') }}
              </h4>
              <div
                v-appear
                class="tenders__delivery-text"
                v-html="$t('tendersTab1DeliveryDescription')"
              />
            </div>
            <div class="tenders__delivery-image animationFade-img">
              <img v-appear v-lazy="tendersDelivery" alt="" />
            </div>
          </div>
          <div v-appear class="tenders__items">
            <h4 class="tenders__items-h4" v-html="$t('tendersTab1ItemsTitle')" />
            <ul class="tenders__items-list">
              <li v-html="$t('tendersTab1Item1')" />
              <li v-html="$t('tendersTab1Item2')" />
              <li v-html="$t('tendersTab1Item3')" />
              <li v-html="$t('tendersTab1Item4')" />
              <li v-html="$t('tendersTab1Item5')" />
              <li v-html="$t('tendersTab1Item6')" />
              <li v-if="te('tendersTab1Item7')" v-html="$t('tendersTab1Item7')"></li>
            </ul>
          </div>
          <div v-appear class="tenders__contacts">
            <h2 class="tenders__contacts-h2" v-html="contacts.text" />
            <table class="table-calc">
              <thead>
                <tr>
                  <th>ФИО</th>
                  <th>Должность</th>
                  <th>Контакты</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Ахунджанов Тимур Бахадирович</td>
                  <td>Руководитель тендерного отдела УК СДЭК</td>
                  <td>
                    <p>e-mail: t.ahundzhanov@cdek.ru</p>
                    <p>Skype: live:e11d1535bda0affb</p>
                  </td>
                </tr>
                <tr>
                  <td>Карасева Дарья Юрьевна</td>
                  <td>Специалист тендерного отдела УК СДЭК</td>
                  <td>
                    <p>e-mail: d.karaseva@cdek.ru</p>
                    <p>Skype: live:.cid.b6ac89e1f6a52e7f</p>
                  </td>
                </tr>
                <tr>
                  <td>Чазова Ирина Константиновна</td>
                  <td>Специалист тендерного отдела УК СДЭК</td>
                  <td>
                    <p>e-mail: ir.chazova@cdek.ru</p>
                    <p>skype: iriwka83</p>
                  </td>
                </tr>
                <tr>
                  <td>Исаченко Алёна Сергеевна</td>
                  <td>Специалист тендерного отдела УК СДЭК</td>
                  <td>
                    <p>e-mail: a.isachenko@cdek.ru</p>
                    <p>Skype: live:fcda640a3713bbb6</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="tenders__connection" v-html="$t('tendersTab1Connection')" />
        </div>
      </tab>
      <tab id="suppliers" :name="$t('tendersTab2Name')" class="text-animationFade">
        <div class="containerMF">
          <h2 v-appear class="tenders__h2">
            {{ $t('tendersTab2Title') }}
          </h2>
          <div v-appear class="tenders__text" v-html="$t('tendersTab2Description')" />
        </div>

        <div class="containerMF">
          <h3 v-appear class="tenders__h3" v-html="$t('tendersTab2Title2')" />
          <questions-two-blocks
            v-for="(questionsTwo, index) in questions_items2"
            :key="index"
            :params="questionsTwo"
          />
        </div>
      </tab>
      <tab
        id="accreditation"
        :name="$t('tendersTab3Name')"
        class="text-animationFade"
        link="https://tender-buy.cdek.ru/"
      >
        <!--        <FormAccreditation :params="formAccreditation" />-->
      </tab>
      <tab
        id="accreditation"
        :name="$t('tendersTab4Name')"
        class="text-animationFade"
        link="https://tender-buy.cdek.ru/Tenders"
      />
    </tabs>
  </div>
</template>

<script>
import Tabs from '@/components/Tabs/lib/Tabs.vue';
import Tab from '@/components/Tabs/lib/Tab.vue';
import QuestionsTwoBlocks from '@/components/QuestionsTwoBlocks.vue';
import ourValues from '@/assets/img/our-values.png';
import tendersDelivery from '@/static/content/tenders_delivery.png';
import { useI18n } from 'vue-i18n';

export default {
  name: 'TheTenders',
  components: {
    Tabs,
    Tab,
    QuestionsTwoBlocks,
  },
  setup() {
    const { te } = useI18n();
    return { te };
  },
  data() {
    return {
      ourValues,
      tendersDelivery,
      questions_items1: [
        {
          frameLeft: {
            frame: {
              title: this.$t('tendersTab1QuestionLeftTitle'),
              list: [
                {
                  type: 'text',
                  text: this.$t('tendersTab1QuestionLeftItem1'),
                },
                {
                  type: 'text',
                  text: this.$t('tendersTab1QuestionLeftItem2'),
                },
                {
                  type: 'text',
                  text: this.$t('tendersTab1QuestionLeftItem3'),
                },
                {
                  type: 'text',
                  text: this.$t('tendersTab1QuestionLeftItem4'),
                },
              ],
            },
          },
          frameRight: {
            frame: {
              title: this.$t('tendersTab1QuestionRightTitle'),
              list: [
                {
                  type: 'text',
                  text: this.$t('tendersTab1QuestionRightItem1'),
                },
                {
                  type: 'text',
                  text: this.$t('tendersTab1QuestionRightItem2'),
                },
                {
                  type: 'text',
                  text: this.$t('tendersTab1QuestionRightItem3'),
                },
              ],
            },
          },
        },
      ],
      questions_items2: [
        {
          frameLeft: {
            frame: {
              title: this.$t('tendersTab2QuestionLeftTitle'),
              list: [
                {
                  type: 'text',
                  text: this.$t('tendersTab2QuestionLeftItem1'),
                },
                {
                  type: 'text',
                  text: this.$t('tendersTab2QuestionLeftItem2'),
                },
              ],
            },
          },
          frameRight: {
            frame: {
              title: this.$t('tendersTab2QuestionRightTitle'),
              list: [
                {
                  type: 'html',
                  text: this.$t('tendersTab2QuestionRightItem1'),
                },
                {
                  type: 'html',
                  text: this.$t('tendersTab2QuestionRightItem2'),
                },
              ],
            },
          },
        },
      ],
      contacts: {
        text: this.$t('tendersTab1InfoTitle'),
      },
      formAccreditation: {
        agreeButton: this.$t('tenders.formAccreditation.agreeButton'),
        companyAddress: this.$t('tenders.formAccreditation.companyAddress'),
        companyCard: this.$t('tenders.formAccreditation.companyCard'),
        companyEmail: this.$t('tenders.formAccreditation.companyEmail'),
        companyINN: this.$t('tenders.formAccreditation.companyINN'),
        companyINNError: this.$t('tenders.formAccreditation.companyINNError'),
        companyINNFile: this.$t('tenders.formAccreditation.companyINNFile'),
        companyKPP: this.$t('tenders.formAccreditation.companyKPP'),
        companyKPPError: this.$t('tenders.formAccreditation.companyKPPError'),
        companyKPPFile: this.$t('tenders.formAccreditation.companyKPPFile'),
        companyName: this.$t('tenders.formAccreditation.companyName'),
        companyOGRN: this.$t('tenders.formAccreditation.companyOGRN'),
        companyOGRNError: this.$t('tenders.formAccreditation.companyOGRNError'),
        companyOGRNFile: this.$t('tenders.formAccreditation.companyOGRNFile'),
        companyOPF: {
          label: this.$t('tenders.formAccreditation.companyOPFLabel'),
          values: [
            {
              title: this.$t('tenders.formAccreditation.companyOPFValue1'),
              value: 'CONTRACT_LEGAL',
            },
            {
              title: this.$t('tenders.formAccreditation.companyOPFValue2'),
              value: 'CONTRACT_IP',
            },
          ],
        },
        companyRealAddress: this.$t('tenders.formAccreditation.companyRealAddress'),
        companyRegDate: this.$t('tenders.formAccreditation.companyRegDate'),
        contactPerson: this.$t('tenders.formAccreditation.contactPerson'),
        mainTitle: this.$t('tenders.formAccreditation.mainTitle'),
        phoneNumber: this.$t('tenders.formAccreditation.phoneNumber'),
        sectionDescription: this.$t('tenders.formAccreditation.sectionDescription'),
        sectionItems: [
          {
            id: 1,
            name: this.$t('tenders.formAccreditation.sectionItems1Name'),
          },
          {
            id: 2,
            name: this.$t('tenders.formAccreditation.sectionItems2Name'),
          },
          {
            id: 3,
            name: this.$t('tenders.formAccreditation.sectionItems3Name'),
          },
          {
            id: 4,
            name: this.$t('tenders.formAccreditation.sectionItems4Name'),
          },
          {
            id: 5,
            name: this.$t('tenders.formAccreditation.sectionItems5Name'),
          },
          {
            id: 6,
            name: this.$t('tenders.formAccreditation.sectionItems6Name'),
          },
          {
            id: 7,
            name: this.$t('tenders.formAccreditation.sectionItems7Name'),
          },
          {
            id: 8,
            name: this.$t('tenders.formAccreditation.sectionItems8Name'),
          },
          {
            id: 9,
            name: this.$t('tenders.formAccreditation.sectionItems9Name'),
          },
          {
            id: 10,
            name: this.$t('tenders.formAccreditation.sectionItems10Name'),
          },
          {
            id: 11,
            name: this.$t('tenders.formAccreditation.sectionItems11Name'),
          },
          {
            id: 12,
            name: this.$t('tenders.formAccreditation.sectionItems12Name'),
          },
          {
            id: 13,
            name: this.$t('tenders.formAccreditation.sectionItems13Name'),
          },
          {
            id: 14,
            name: this.$t('tenders.formAccreditation.sectionItems14Name'),
          },
          {
            id: 15,
            name: this.$t('tenders.formAccreditation.sectionItems15Name'),
          },
        ],
        sectionTitle: this.$t('tenders.formAccreditation.sectionTitle'),
        sendButton: this.$t('tenders.formAccreditation.sendButton'),
        textAfterSending: this.$t('tenders.formAccreditation.textAfterSending'),
      },
      lastTab: 'clients',
    };
  },
  methods: {
    onChangeTabs() {},
  },
};
</script>

<style lang="scss">
@import '@/assets/style/mobileFirst';

.containerMF.tenders__conteiner {
  @media (min-width: 1280px) {
    max-width: 1200px;
  }
}

.tenders {
  padding-top: 52px;

  &__h1 {
    @extend .containerMF__h1;
    @extend .containerMF;

    margin-bottom: 40px;
    padding: 0 10px;
    letter-spacing: -0.1px;

    @media (min-width: $tablet) {
      margin-bottom: 42px;
      padding: 0 20px;
    }

    @media (min-width: $desktop-l) {
      margin: 0 auto;
      margin-bottom: 42px;
      padding: 0;
    }
  }

  &__tabs {
    .tabs-component-tabs {
      position: relative;
      padding: 0;

      @extend .containerMF;

      display: block;
      overflow-x: auto;
      margin: 0 auto;

      &::-webkit-scrollbar {
        width: 0;
      }

      &::before {
        position: absolute;
        z-index: 1;
        right: -100%;
        bottom: 0;
        left: -100%;
        height: 2px;
        content: '';
        border-bottom: 2px solid #e1e1e1;

        @media (min-width: $desktop) {
          right: 0;
          left: 0;
          width: calc(100% - 20px);
        }

        @media (min-width: $desktop-l) {
          width: 100%;
        }
      }

      @media (min-width: $desktop) {
        overflow-x: visible;
        margin-left: 22px;
      }

      @media (min-width: $desktop-l) {
        margin: 0 auto;
      }
    }

    .tabs-component-tab {
      position: relative;
      display: inline-block;
      padding: 0 10px 20px;
      list-style-type: none;
      color: $base-color;
      font-size: 15px;
      font-weight: 300;

      &.is-active {
        &::before {
          position: absolute;
          z-index: 1;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 2px;
          content: '';
          border-bottom: 2px solid #1ab248;
        }
      }

      @media (min-width: $tablet) {
        padding: 0 20px 23px;
      }

      @media (min-width: $desktop) {
        margin-right: 21px;
      }
    }

    .tabs-component-tab-a {
      display: block;
      text-decoration: none;
      color: $base-color;
      font-size: 15px;
      font-weight: 300;

      @media (min-width: $tablet) {
        font-size: 20px;
      }
    }
  }

  &__h2 {
    @extend .contentMF;
    @extend .containerMF__h2;

    margin-bottom: 59px;
    padding-top: 38px;
    letter-spacing: -0.05px;
    font-size: 20px;
    font-weight: 300;
    line-height: 29px;

    &--link-two {
      margin-bottom: 42px;

      @media (min-width: $tablet) {
        max-width: 532px;
        margin-bottom: 43px;
      }

      @media (min-width: $desktop) {
        max-width: 740px;
        margin-bottom: 40px;
      }

      @media (min-width: $desktop-l) {
        max-width: 705px;
        padding-top: 42px;
      }
    }

    @media (min-width: $tablet) {
      margin-bottom: 40px;
      padding-top: 44px;
      letter-spacing: 0.05px;
      font-size: 24px;
      font-weight: 300;
      line-height: 37px;
    }

    @media (min-width: $desktop) {
      width: 100%;
      max-width: 720px;
      margin-bottom: 40px;
      padding-top: 45px;
      font-size: 34px;
      line-height: 50px;
    }

    @media (min-width: $desktop-l) {
      margin-bottom: 117px;
      padding-top: 86px;
    }
  }

  &__delivery {
    margin-bottom: 68px;

    @media (min-width: $tablet) {
      display: flex;
      justify-content: space-between;
      margin-bottom: 97px;
    }

    @media (min-width: $desktop) {
      margin-bottom: 115px;
    }

    @media (min-width: $desktop-l) {
      max-width: 1200px;
      margin-right: auto;
      margin-bottom: 196px;
      margin-left: auto;
    }
  }

  &__delivery-content {
    @extend .contentMF;

    margin-bottom: 42px;

    @media (min-width: $tablet) {
      flex: 0 1 auto;
      margin-bottom: 0;
    }

    @media (min-width: $desktop) {
      padding-top: 34px;
    }

    @media (min-width: $desktop-l) {
      flex: 0 1 540px;
      padding-top: 70px;
    }
  }

  &__delivery-h4 {
    @extend .containerMF__h4;

    display: inline-block;
    width: 240px;
    margin-bottom: 18px;
    line-height: 37px;

    @media (min-width: $desktop) {
      width: auto;
      line-height: 45px;
    }

    @media (min-width: $desktop-l) {
      width: auto;
      margin-bottom: 38px;
    }
  }

  &__delivery-string {
    @media (min-width: $desktop) {
      display: inline-block;
      width: 300px;
    }

    @media (min-width: $desktop-l) {
      display: inline;
    }
  }

  &__delivery-text {
    @extend .containerMF__text;

    p {
      margin-bottom: 22px;
    }

    @media (min-width: $tablet) {
      padding-right: 10px;
    }

    @media (min-width: $desktop) {
      line-height: 32px;
    }
  }

  &__delivery-image {
    &.values {
      padding: 0 50px 0 20px;

      @media (min-width: $tablet) {
        padding-top: 50px;
      }
    }

    img {
      width: 100%;
    }

    @media (min-width: $tablet) {
      flex: 1 0 319px;
      padding-top: 11px;
    }

    @media (min-width: $desktop) {
      flex: 1 0 499px;
      padding-top: 0;
    }

    @media (min-width: $desktop-l) {
      flex: 0 1 530px;
    }
  }

  &__items {
    @extend .contentMF;

    max-width: 515px;
    margin-bottom: 82px;

    @media (min-width: $tablet) {
      margin-bottom: 102px;
    }

    @media (min-width: $desktop) {
      display: flex;
      justify-content: space-between;
      max-width: none;
      margin-bottom: 135px;
    }

    @media (min-width: $desktop-l) {
      max-width: 1200px;
      margin-right: auto;
      margin-bottom: 189px;
      margin-left: auto;
    }
  }

  &__items-h4 {
    @extend .containerMF__h4;

    margin-bottom: 27px;

    @media (min-width: $tablet) {
      margin-bottom: 23px;
    }

    @media (min-width: $desktop) {
      flex: 1 0 460px;
      margin-right: 20px;
      line-height: 42px;
    }

    @media (min-width: $desktop-l) {
      flex: 0 1 490px;
    }

    @media (max-width: $tablet) {
      line-height: 35px;
    }
  }

  &__items-list {
    padding: 0;
    font-size: 16px;
    font-weight: 300;

    li {
      margin-bottom: 22px;
      padding: 0;
      list-style: none;

      &:last-child {
        margin-bottom: 0;
        height: 40px;
      }

      &::before {
        position: static;
      }

      b {
        font-weight: 500;
      }
    }

    @media (min-width: $desktop) {
      flex: 0 1 auto;
      width: 450px;
      font-size: 20px;
    }

    @media (min-width: $desktop-l) {
      flex: 0 1 579px;
    }
  }

  &__contacts {
    overflow-x: scroll;
    padding: 39px 10px 63px;
    background-color: #f9f9f9;

    &-h2 {
      margin-bottom: 47px;
      letter-spacing: -0.05px;
      font-size: 20px;
      font-weight: 200;
      line-height: 30px;

      b {
        font-weight: 400;
      }

      @media (min-width: $tablet) {
        margin-bottom: 25px;
      }

      @media (min-width: $desktop) {
        width: 1000px;
        margin-bottom: 53px;
        font-size: 34px;
        line-height: 52px;
      }
    }

    .questions-two {
      margin-bottom: 0 !important;

      &__block {
        flex-shrink: 1;
      }
    }

    @media (min-width: $tablet) {
      padding: 39px 20px 87px;
    }

    @media (min-width: $desktop) {
      margin-bottom: 80px;
      padding: 73px 20px 70px;
    }

    @media (min-width: $desktop-l) {
      margin-bottom: 138px;
      padding: 73px 20px 70px 55px;
    }
  }

  &__connection {
    @extend .contentMF;

    max-width: 239px;
    margin-bottom: 80px;

    @media (min-width: $tablet) {
      max-width: 530px;
      margin-bottom: 95px;
    }

    @media (min-width: $desktop) {
      max-width: 650px;
      margin-bottom: 139px;
    }

    @media (min-width: $desktop-l) {
      max-width: 1200px;
      margin-right: auto;
      margin-bottom: 114px;
      margin-left: auto;
      padding-left: 50px;
    }
  }

  &__connection-text {
    font-size: 16px;
    font-weight: 600;

    @media (min-width: $desktop) {
      letter-spacing: 0.1px;
      font-size: 20px;
    }
  }

  &__connection-top {
    margin-bottom: 20px;
  }

  &__connection-link {
    @extend .containerMF__link;
    @extend .containerMF__linkGreen;

    font-size: 16px;

    @media (min-width: $desktop) {
      margin-bottom: 23px;
      font-size: 20px;
    }
  }

  &__connection-bottom {
    a {
      text-decoration: none;
      color: $base-color;
      font-weight: 600;
    }
  }

  &__text {
    @extend .containerMF__text;
    @extend .contentMF;

    margin-bottom: 80px;

    ol {
      margin-bottom: 23px;
    }

    p {
      margin-bottom: 22px;
    }

    @media (min-width: $tablet) {
      margin-bottom: 100px;
    }

    @media (min-width: $desktop) {
      max-width: 780px;
      margin-bottom: 138px;

      p {
        margin-bottom: 26px;
      }
    }

    @media (min-width: $desktop-l) {
      margin-bottom: 98px;
    }
  }

  &__actual {
    margin-bottom: 80px;
    padding: 38px 10px 15px;
    background-color: $LightGray;

    @media (min-width: $tablet) {
      margin-bottom: 100px;
      padding: 38px 20px 62px;
    }

    @media (min-width: $desktop) {
      margin-bottom: 100px;
      padding: 63px 20px 75px;
    }

    @media (min-width: $desktop-l) {
      width: 100%;
      max-width: 1320px;
      margin: 0 auto;
      margin-bottom: 175px;
      margin-bottom: 90px;
      padding: 63px 60px 75px;
    }
  }

  &__actual-h5 {
    @extend .containerMF__h5;

    margin-bottom: 13px;
    color: $base-color;

    @media (min-width: $desktop) {
      margin-bottom: 22px;
    }
  }

  &__actual-text {
    @extend .containerMF__text;

    margin-bottom: 41px;

    @media (min-width: $tablet) {
      max-width: 470px;
      margin-bottom: 53px;
    }

    @media (min-width: $desktop) {
      max-width: 752px;
      margin-bottom: 58px;
    }
  }

  &__actual-button {
    @include button(Gray, 100%, $BtnMin, auto);

    margin: 0 auto 20px;
    letter-spacing: 1.2px;

    @media (min-width: $tablet) {
      flex: 0 1 300px;
      margin: 0;
      margin-right: 31px;
    }

    @media (min-width: $desktop) {
      margin-right: 52px;
    }
  }

  &__actual-info {
    text-align: center;
    font-size: 20px;
    font-weight: 300;

    @media (min-width: $tablet) {
      flex: 0 1 auto;
      margin: 0;
    }
  }

  &__actual-link {
    @extend .containerMF__link;
    @extend .containerMF__linkGreen;
  }

  &__actual-bottom {
    @media (min-width: $tablet) {
      display: flex;
      align-items: center;
    }
  }

  &__h3 {
    @extend .contentMF;
    @extend .containerMF__h3;

    margin-bottom: 30px;
    color: $base-color;
    font-weight: 300;
    line-height: 32px;

    @media (min-width: $tablet) {
      max-width: 500px;
      margin-bottom: 50px;
      font-size: 24px;
      line-height: 40px;
    }

    @media (min-width: $desktop) {
      max-width: 700px;
      font-size: 34px;
      line-height: 45px;
    }
  }

  &__string {
    @media (max-width: $desktop) {
      display: inline-block;
      line-height: 35px;
    }
  }

  @media (min-width: $desktop) {
    padding-top: 134px;
  }

  .numbers {
    @media (min-width: $desktop-l) {
      margin-bottom: 140px;
    }
  }

  .questions-two {
    @media (min-width: $tablet) {
      margin-bottom: 60px;
    }

    @media (min-width: $desktop) {
      margin-bottom: 150px;
    }
  }
}

.tenders .questions-two.text-animationFade {
  @media (min-width: $desktop-l) {
    max-width: 1200px;
    margin-right: auto;
    margin-left: auto;
  }
}

.table-calc {
  width: 100%;
  border-spacing: 0;
  border: 0 none;

  thead th {
    padding: 17px;
    text-align: left;
    border-bottom: 1px solid rgba(67, 76, 93, 0.2);
    background-color: #eceff3;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;

    &:first-child {
      width: 40%;
    }
  }

  tbody tr {
    & td {
      padding: 17px;
      background-color: #fff;
      font-size: 16px;
    }

    &:nth-child(even) td {
      background-color: #eceff3;
    }
  }
}
</style>
